import React, { useState } from "react";
import { Dialog, DialogActions, DialogContent, TextField } from "@mui/material";
import { styled } from "@mui/material/styles";
import CloseIcon from "@mui/icons-material/Close";
import Button from "../../../component-lib/Molecules/button/Button";
import Heading from "../../../component-lib/Atoms/heading/EventEHRHeading";
import { TEXT_CONSTANTS } from "../../../utils/text-constants/textConstants";

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  "& .MuiDialogContent-root": {
    padding: "16px 24px",
  },
  "& .MuiDialogActions-root": {
    padding: theme.spacing(1),
  },
  "& .MuiPaper-root": {
    borderRadius: "8px",
    width: "708px",
    maxWidth: "none",
  },
}));

interface BroadcastMessageDialogProps {
  isOpen: boolean;
  handleClose: () => void;
  handleSend: (content: string) => void;
}

const BroadcastMessageDialog = ({
  isOpen = false,
  handleClose,
  handleSend,
}: BroadcastMessageDialogProps) => {
  const [content, setContent] = useState("");

  return (
    <BootstrapDialog
      onClose={(event: any, reason: string) => {
        if (reason !== "backdropClick") {
          handleClose();
        }
      }}
      aria-labelledby="broadcast-message-title"
      open={isOpen}
    >
      <div className="flex justify-between items-center rounded-lg p-4">
        <Heading title="Broadcast Message" />
        <div onClick={handleClose}>
          <CloseIcon className="cursor-pointer" />
        </div>
      </div>
      <DialogContent dividers>
        <TextField
          fullWidth
          multiline
          minRows={4}
          maxRows={8}
          placeholder="Type your message to broadcast to everyone ..."
          value={content}
          onChange={(e) => setContent(e.target.value.slice(0, 500))}
          inputProps={{ maxLength: 500 }}
        />
      </DialogContent>
      <DialogActions>
        <div className="p-2 flex gap-2">
          <Button
            label={TEXT_CONSTANTS?.CANCEL}
            variant="outlined"
            onClickCb={handleClose}
            style={{
              width: "120px",
              height: "44px",
              padding: "12px 20px",
              fontSize: "16px",
              backgroundColor: "white",
              color: "#393939",
            }}
          />
          <Button
            label="Send"
            variant="contained"
            disabled={!content.trim()}
            onClickCb={() => handleSend(content.trim())}
            style={{
              width: "120px",
              height: "44px",
              padding: "12px 20px",
              fontSize: "16px",
            }}
          />
        </div>
      </DialogActions>
    </BootstrapDialog>
  );
};

export default BroadcastMessageDialog;
